var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageBox"},[_c('PageComponent',{attrs:{"publicTemplateName":"访问后未填报员工信息单位的应训人员","publicStatus":2200}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }